// How a listing ships, from its delivery options: a Tutulist label ('tutulist'), the seller's own
// shipping ('shipping', or 'freeShipping' at no charge), and/or pickup. Checkout uses this so an
// item that ships always asks the buyer how it ships; the server refuses a purchase that doesn't
// (server/api-util/shippingRequired.js).

const TUTULIST_LABEL = 'tutulist';
const SHIPPED_OPTIONS = [TUTULIST_LABEL, 'shipping', 'freeShipping'];

const deliveryOptionsOf = listing => {
  const options = listing?.attributes?.publicData?.deliveryOptions;
  return Array.isArray(options) ? options : [];
};

/** Whether the listing ships (by Tutulist label or the seller's own shipping). */
export const listingShips = listing => {
  const options = deliveryOptionsOf(listing);
  if (options.length > 0) {
    return options.some(option => SHIPPED_OPTIONS.includes(option));
  }
  return listing?.attributes?.publicData?.shippingEnabled === true;
};

/** Whether the listing ships with a Tutulist label the buyer pays for at checkout. */
export const listingShipsWithTutulistLabel = listing =>
  deliveryOptionsOf(listing).includes(TUTULIST_LABEL);

/** Whether the seller ships the listing themselves, free. */
export const listingShipsFreeByOwnShipping = listing =>
  deliveryOptionsOf(listing).includes('freeShipping');

/** Whether the listing ships and can't be picked up, so shipping is the only way. */
export const listingOnlyShips = listing =>
  listingShips(listing) && !deliveryOptionsOf(listing).includes('pickup');
